{
  "agb-to-accept-dialog": {
    "buttons": {
      "agree": "Einverstanden",
      "deny-and-logout": "Ablehnen und Abmelden"
    },
    "text": {
      "agb": "Allgemeine Geschäftsbedingungen (AGB)"
    }
  }
}
